<div class="conn-card">
    <app-report-top-filter-bar
        *ngIf="0 == 0"
        [paraReportName]="'credit-card-sales-report'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (exportCsvFn)="dt.exportCSV()"
    ></app-report-top-filter-bar>

    <!-- [scrollable]="true" -->
    <p-table
        [globalFilterFields]="[
            'customerName',
            'invoiceNumber',
            'cashier',
            'type',
            'entryMethod',
            'last4'
        ]"
        [value]="dataList"
        dataKey="invoiceNumber"
        #dt
        [columns]="csvcols"
        styleClass="p-datatable-striped"
        [autoLayout]="true"
        [resizableColumns]="true"
        *ngIf="dataList?.length > 0"
    >
        <ng-template pTemplate="caption">
            <div class="p-d-flex">
                <span class="p-input-icon-left p-ml-auto">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="
                            dt.filterGlobal($event.target.value, 'contains')
                        "
                        placeholder="Search keyword"
                    />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!-- <th style="text-align: center" *ngFor="let col of domColHeader">
                    <strong>{{ col }}</strong>
                </th> -->
                <th style="text-align: left; vertical-align: middle">Name</th>
                <th style="text-align: right; vertical-align: middle">Sale</th>
                <th style="text-align: right; vertical-align: middle">Fees</th>
                <th style="text-align: right; vertical-align: middle">Return</th>
                <th style="text-align: right; vertical-align: middle">Voids</th>
                <th style="text-align: left; vertical-align: middle">Type</th>
                <th style="text-align: left; vertical-align: middle">Last 4</th>
                <th style="text-align: left; vertical-align: middle">Approval</th>
                <th style="text-align: left; vertical-align: middle">Invoice</th>
                <th style="text-align: left; vertical-align: middle">Ref#</th>
                <th style="text-align: left; vertical-align: middle">Entry Method</th>
                <th style="text-align: left; vertical-align: middle">Station</th>
                <th style="text-align: left; vertical-align: middle">Date</th>
                <th style="text-align: left; vertical-align: middle">Time</th>
                <th style="text-align: left; vertical-align: middle">Clerk</th>
                <th style="text-align: right; vertical-align: middle">Tip Amount</th>
                <th style="text-align: right; vertical-align: middle">Charged</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded">
            <tr>
                <!-- <td title="Customer ID"> </td> -->
                <td style="text-align: left; vertical-align: middle">{{ product.customerName }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.sales | currency | currencySpacing }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.feesTotal | currency | currencySpacing }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.returns | currency | currencySpacing }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.voids | currency | currencySpacing }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.type }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.last4 }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.approval }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.invoiceNumber }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.refNumber }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.entryMethod }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.station }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.date }}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.time}}</td>
                <td style="text-align: left; vertical-align: middle">{{ product.cashier }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.tipAmount | currency | currencySpacing }}</td>
                <td style="text-align: right; vertical-align: middle">{{ product.invoiceTotal | currency | currencySpacing }}</td>
            </tr>
        </ng-template>
    </p-table>
    <div class="flex" *ngIf="dataList?.length == 0">
        <div class="flex justify-content-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">
                No data found!</span
            >
        </div>
    </div>
</div>
